import { Procedimento } from './procedimento.model';

/**
 * Modelo de classe para representar os antendimentos.
 */
export class Atendimento {
    id: number;
    procedimento: Procedimento;
    valorUnitario: number;
    quantidade: number;
    valorTotal: number;

    procedimentoId: any;
}
